/*
 * @Author: Zhouqi
 * @Date: 2025-12-15 10:07:40
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:24:29
 */
import InputErrorIcon from '@/components/icons/InputErrorIcon';

const InputError = ({ message }: { message?: string }) => (
  <div className="py-1 px-[2px] flex justify-start items-center gap-1">
    <div className="w-4 h-4">
      <InputErrorIcon></InputErrorIcon>
    </div>

    <span className="p-style" style={{ color: 'var(--warning, #DE014A)' }}>
      {message}
    </span>
  </div>
);

export default InputError;
